import { render, staticRenderFns } from "./MobileAppVersions.vue?vue&type=template&id=60452ed8"
import script from "./MobileAppVersions.vue?vue&type=script&lang=ts"
export * from "./MobileAppVersions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports